/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncEntities} from '../api'

export const useMutationsyncEntities = createReactQueryMutationHook('syncEntities', syncEntities)
